import { NgModule } from '@angular/core';
import { EpmExampleComponent } from './epm-example.component';



@NgModule({
  declarations: [EpmExampleComponent],
  imports: [
  ],
  exports: [EpmExampleComponent]
})
export class EpmExampleModule { }
